import React from "react";
import { motion } from "framer-motion";

export default function ProfileSection({ isScrolled = false }) {
  const containerVariants = {
    initial: {},
    animate: {
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const profileImageVariants = {
    initial: { scale: 0, rotate: -180 },
    animate: {
      scale: 1,
      rotate: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 15,
        duration: 1.2
      }
    }
  };

  const floatingAnimation = {
    y: [-5, 5],
    transition: {
      y: {
        duration: 2,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut"
      }
    }
  };

  const textVariants = {
    initial: { opacity: 0, y: 30 },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const socialIconVariants = {
    initial: { opacity: 0, scale: 0 },
    animate: {
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20
      }
    }
  };

  const socialContainerVariants = {
    initial: {},
    animate: {
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  return (
    <motion.div
      className="text-center"
      variants={containerVariants}
      initial="initial"
      animate="animate"
    >
      {/* Compact Header */}
      <motion.div 
        className="flex flex-col sm:flex-row items-center justify-center sm:space-x-6"
        variants={textVariants}
        animate={{
          marginBottom: isScrolled ? "4px" : "24px"
        }}
        transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
      >
        {/* Profile Image */}
        <motion.div 
          className="rounded-full bg-gradient-to-br from-purple-50 to-blue-50 flex items-center justify-center overflow-hidden shadow-lg border-2 border-purple-100 hover:shadow-xl transition-all duration-300 hover:scale-105 mb-4 sm:mb-0"
          animate={{
            width: isScrolled ? "56px" : "64px",
            height: isScrolled ? "56px" : "64px"
          }}
          transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          <motion.div 
            className="bg-gradient-to-br from-purple-400 to-blue-500 flex items-center justify-center text-white font-bold rounded-full shadow-inner"
            animate={{
              width: isScrolled ? "44px" : "48px",
              height: isScrolled ? "44px" : "48px",
              fontSize: isScrolled ? "13px" : "14px"
            }}
            transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            &lt;HB/&gt;
          </motion.div>
        </motion.div>

        {/* Name and Title */}
        <div className="text-center sm:text-left">
          <motion.h1
            className="font-bold text-gray-900 mb-1"
            whileHover={{ scale: 1.02 }}
            animate={{
              fontSize: isScrolled ? "20px" : "24px"
            }}
            transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            Haris Butt
          </motion.h1>
          <motion.p
            className="text-gray-600"
            whileHover={{ color: "#374151" }}
            animate={{
              fontSize: isScrolled ? "13px" : "14px",
              opacity: isScrolled ? 0.9 : 1
            }}
            transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
          >
            <span className="font-semibold text-gradient-soft">Shopify Developer</span> & E-commerce Expert
          </motion.p>
        </div>
      </motion.div>

      {/* Quick Description */}
      <motion.div 
        className="text-center"
        variants={textVariants}
        animate={{
          marginBottom: isScrolled ? "8px" : "24px"
        }}
        transition={{ 
          duration: 0.5, 
          ease: [0.25, 0.46, 0.45, 0.94]
        }}
      >
        <motion.p
          className="text-gray-600 max-w-2xl mx-auto px-4"
          whileHover={{ color: "#374151" }}
          animate={{
            fontSize: isScrolled ? "12px" : "14px",
            opacity: isScrolled ? 0.7 : 1,
            lineHeight: isScrolled ? "1.4" : "1.5"
          }}
          transition={{ duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }}
        >
          I build high-converting Shopify stores that scale. Specializing in custom themes, apps, and performance optimization.
        </motion.p>
      </motion.div>

    </motion.div>
  );
} 